import ResponseHelper from './response-helper';

/**
 * Lib that manages communication with Vizzto server related to content of static pages.
 * Returns with `code = 0` are considered sucessfull.
 */

export default (axios) => ({
  /**
   * Gets text of terms of use.
   * @param {Number} distributorId Distributor id
   * @returns {Promise}
   */
  getTermsOfUse(distributorId) {
    return axios
      .$get(`terms/${distributorId}`)
      .then(function (response) {
        let text = 'Termos de uso não foram encontrados.';
        if (response.length > 0) {
          text = response.find(
            (item) => item.termType === 'TERMS_OF_USE'
          )?.text;
        }
        return Promise.resolve({
          data: { terms: text },
          code: 0,
          message: 'OK'
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  },

  /**
   * Gets text of privacy policy.
   * @param {Number} distributorId Distributor id
   * @returns {Promise}
   */
  getPrivacyPolicy(distributorId) {
    return axios
      .$get(`terms/${distributorId}`)
      .then(function (response) {
        let text = 'Políticas de privacidade não foram encontradas.';
        if (response.length > 0) {
          text = response.find(
            (item) => item.termType === 'PRIVACY_POLICY'
          )?.text;
        }
        return Promise.resolve({
          data: { terms: text },
          code: 0,
          message: 'OK'
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  }

  /**
   * Get the html content of a static page.
   * @param {String} distributorId
   * @param {String} pageId The page id (usually the parameter of /p/* route).
   * @returns {Promise<{code: number, data: {content: string}, message: string}>}
   */
  /* TODO: Enable this when available.
  getStaticPage: function (distributorId, pageId) {
    return Promise.resolve({
      code: 0,
      message: 'OK, here is the content of that page.',
      data: {
        content: '<h1>Oi, eu sou o título</h1><p>Grandes coisa, eu sou o parágrafo.</p>'
      }
    });
  }
  */
});
